export function startLoad(key, value, noTimeout) {
  return {
    type: 'START_LOAD',
    key,
    value,
    noTimeout,
  };
}

export function finishLoad(key) {
  return {
    type: 'FINISH_LOAD',
    key,
  };
}
